import create from 'zustand';

const [useStore] = create((set) => ({
  place: 'airport',
  navigationStatus: (status) => set(() => ({ place: status })),
  isDirty: false,
  setIsDirty: (isDirty) => set(() => ({ isDirty })),
  currentAirportId: null,
  setCurrentAirportId: (currentAirportId) => set(() => ({ currentAirportId })),
  alertState: {
    open: false,
    message: '',
  },
  handleAlert: (alertParams) => set(() => ({ alertState: { ...alertParams } })),
}));

const [useUserStore] = create((set) => ({
  selectedUser: null,
  setSelectedUser: (selectedUser) => set(() => ({ selectedUser })),
}));

// const [useContactStore] = create((set) => ({
//   selectedContact: null,
//   setSelectedContact: (selectedContact) => set(() => ({ selectedContact })),
// }));
// const selectedContactSelector = (state) => ({
//   selectedContact: state.selectedContact,
// });
// const setSelectedContactSelector = (state) => ({
//   setSelectedContact: state.setSelectedContact,
// });

const [useGlobalUxStore] = create((set) => ({
  currentPageName: '',
  setCurrentPageName: (currentPageName) => set(() => ({ currentPageName })),
}));
const currentPageNameSelector = (state) => ({
  currentPageName: state.currentPageName,
});
const setCurrentPageNameSelector = (state) => ({
  setCurrentPageName: state.setCurrentPageName,
});

export {
  useStore,
  useUserStore,
  useGlobalUxStore,
  currentPageNameSelector,
  setCurrentPageNameSelector,
  // useContactStore,
  // selectedContactSelector,
  // setSelectedContactSelector,
};
